import React, { Suspense, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

import AgntLoginScreen from "../screens/auth/agent/login";
import RegisterScreen from "../screens/auth/agent/register";
import AddPasswordScreen from "../screens/auth/agent/add-password";
import VerifyYourAccountScreen from "../screens/auth/agent/verify-account";
import CompanyRegistrationScreen from "../screens/auth/agent/company-registration";
import ForgotPasswordScreen from "../screens/auth/agent/forgot-password";
import EmailverificationScreen from "../screens/auth/agent/email-verification";
import ResetPasswordScreen from "../screens/auth/agent/reset-password";
import AgntDashboardScreen from "../screens/agent-flow/dashboard";
import AgentApplicationsScreen from "../screens/agent-flow/applications";
import AgentprofileAccountDetailsScreen from "../screens/agent-flow/account-details";
import AgentManageJobsScreen from "../screens/agent-flow/manage-jobs";

import Home from "../screens/home";
import AboutScreen from "../screens/about";
import BlogListScreen from "../screens/blog";
import FaqScreen from "../screens/faq";
import ContactUsScreen from "../screens/contact-us";
import JoblistingScreen from "../screens/job-listing";
import JobDetailsScreen from "../screens/job-details";
import BlogDetailsScreen from "../screens/blog-details";
import OurRecruitmentServicesScreen from "../screens/our-recruitment-services";
import EmployerScreen from "../screens/employer";
import OurServicesScreen from "../screens/services";

import DashboardScreen from "../screens/jobseeker/dashboard";
import JobsMessageScreen from "../screens/jobseeker/message";
import JobsListingScreen from "../screens/jobseeker/jobs-listing";
import JobsDetailsScreen from "../screens/jobseeker/jobs-details";
import AppliedJobScreen from "../screens/jobseeker/applied-job";
// import JobseekerRegisterScreen from '../screens/auth/jobs/jobs-register';
// import JobseekerLoginScreen from '../screens/auth/jobs/jobs-login';
// import JobseekerForgotPasswordScreen from '../screens/auth/jobs/jobs-forgot-password';
// import JobseekerEmailVerificationScreen from '../screens/auth/jobs/jobs-email-verification';
// import JobseekerResetPasswordScreen from '../screens/auth/jobs/jobs-reset-password';
// import JobseekerAddPasswordScreen from '../screens/auth/jobs/jobs-add-password';
// import JobseekerVerifyAccountScreen from '../screens/auth/jobs/jobs-verify-account';
import RequestImmigrationFormScreen from "../screens/jobseeker/request-immigration-form";
import ProfileAccountDetailsScreen from "../screens/jobseeker/resume-account-details";
import ProfileMyResumeScreen from "../screens/jobseeker/my-resume";
import ProfileExperienceScreen from "../screens/jobseeker/resume-experience";
import ProfileAddedWorkExperienceScreen from "../screens/jobseeker/resume-added-work-experience";
import ProfileEducationInformationScreen from "../screens/jobseeker/resume-education-information";
import ResumeAfterAddedEducationInformationScreen from "../screens/jobseeker/resume-after-added-education-information";
import ResumeAchievementsInformationScreen from "../screens/jobseeker/resume-achievements-information";
import ResumeAfterAddedAchivementsInformationScreen from "../screens/jobseeker/resume-after-added-achievements-information";
import ResumeQualificationInformationScreen from "../screens/jobseeker/resume-qualification-information";
import ResumeAfteraddedQualificationInformationScreen from "../screens/jobseeker/resume-after-added-qualification-information";
import JobseekerSettingsScreen from "../screens/jobseeker/settings";

import ManageJobsScreen from "../screens/employer/manage-jobs";
// import EMPLoginScreen from '../screens/auth/emp/login';
// import EMPRegisterScreen from '../screens/auth/emp/register';
// import EMPAddPassrowdScreen from '../screens/auth/emp/add-password';
// import EMPCompanyRegistrationScreen from '../screens/auth/emp/company-registration';
// import EMPEmailVerificationScreen from '../screens/auth/emp/email-verification';
// import EMPForgotPasswordScreen from '../screens/auth/emp/forgot-password';
// import EMPResetPasswordScreen from '../screens/auth/emp/reset-password';
// import EMPVerifyAccountScreen from '../screens/auth/emp/verify-account';
import EMPDashboardScreen from "../screens/employer/dashboard";
import EmpPostajobScreen from "../screens/employer/post-a-job";
import EmpApplicantsScreen from "../screens/employer/applicants";
import EmpAccountDetailsScreen from "../screens/employer/account-details";
import EmpEditJobScreen from "../screens/employer/edit-job";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { globalContentsApi } from "../service/apis/globalcontents.api";
import Notification from "../screens/jobseeker/notification";
import Layout from "../component/layout/layout";
import OurImmigrationServicesScreen from "../screens/our-immigration-services";
import TermsScreen from "../screens/terms";
import PrivacyScreen from "../screens/privacy-policy";
import NotFound from "../component/notfound-page";
import Loader from "../common/Loader/loader";
import JobSeekerScreen from "../screens/jobseeker";
import LocalAgentScreen from "../screens/local-agency";

const AppRouter = () => {
  const dispatch = useDispatch(); // Initialize dispatch function

  const { isLoggedIn } = useSelector((state: RootState) => state.authSlice);

  const globalContents = async () => {
    await globalContentsApi(dispatch);
  };
  useEffect(() => {
    // Dispatch the async thunk to fetch global data
    globalContents();
    // eslint-disable-next-line
  }, []);
  const userRole = useSelector((state: RootState) => {
    // console.log(state);
    return state.authSlice.user?.role;
  });
  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null; // This component doesn't render anything
  };

  const ProtectedRoute = ({
    children,
    role,
  }: {
    children: JSX.Element;
    role: string;
  }) => {
    // console.log(userRole);
    if (!userRole) return <Navigate to="/" />;
    return userRole === role ? children : <Navigate to="/" />;
  };

  const StrictlyNotRequireAuth = ({ isAuthenticated }: any) => {
    let location = useLocation();

    if (isAuthenticated) {
      return userRole === "jobseeker" ? (
        <Navigate to="/jobseeker/dashboard" state={{ from: location }} />
      ) : userRole === "localagents" ? (
        <Navigate to="/agent-flow/dashboard" state={{ from: location }} />
      ) : userRole === "employer" ? (
        <Navigate to="/employer/dashboard" state={{ from: location }} />
      ) : (
        <Navigate to="/" state={{ from: location }} />
      );
    }
    return (
      <Suspense fallback={<Loader />}>
        <AgntLoginScreen />
      </Suspense>
    );
  };

  return (
    <BrowserRouter>
      {/* <ToastContainer
        // position="bottom-center"
        autoClose={3000}
        hideProgressBar
        draggable={false}
        limit={1}
        role="alert"
        icon={false}
        theme="light"
        transition={Flip}
        style={{
          marginTop: "30px",
          marginLeft: "30px",
          maxWidth: "300px",
          height: "30px",
        }}
      /> */}
      <ToastContainer />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<AboutScreen />} />
          <Route path="blog" element={<BlogListScreen />} />
          <Route path="blog-details/:blogId" element={<BlogDetailsScreen />} />
          <Route path="contact-us" element={<ContactUsScreen />} />
          <Route path="faq" element={<FaqScreen />} />
          <Route path="job-listing" element={<JoblistingScreen />} />
          <Route path="job-details" element={<JobDetailsScreen />} />
          <Route
            path="our-recruitment-services"
            element={<OurRecruitmentServicesScreen />}
          />
          <Route
            path="our-immigration-services"
            element={<OurImmigrationServicesScreen />}
          />
          <Route path="employer" element={<EmployerScreen />} />
          <Route path="jobseeker" element={<JobSeekerScreen />} />
          <Route path="local-agency" element={<LocalAgentScreen />} />
          <Route path="services" element={<OurServicesScreen />} />
          <Route path="terms-conditions" element={<TermsScreen />} />
          <Route path="privacy-policy" element={<PrivacyScreen />} />
        </Route>

        {/* Auth Routes starts */}
        <Route
          element={<StrictlyNotRequireAuth isAuthenticated={isLoggedIn} />}
        >
          <Route path="login" element={<AgntLoginScreen />} />
        </Route>
        <Route path="forgot-password" element={<ForgotPasswordScreen />} />
        <Route path="reset-password" element={<ResetPasswordScreen />} />
        <Route
          path="emp/register"
          element={
            // <EMPRegisterScreen />
            <RegisterScreen />
          }
        />
        <Route path="emp/add-password" element={<AddPasswordScreen />} />
        <Route
          path="emp/verify-account"
          element={<VerifyYourAccountScreen />}
        />
        <Route
          path="emp/company-registration"
          element={<CompanyRegistrationScreen />}
        />
        <Route
          path="jobs/jobs-register"
          element={
            // <JobseekerRegisterScreen />
            <RegisterScreen />
          }
        />
        <Route path="agent/register" element={<RegisterScreen />} />

        <Route path="agent/add-password" element={<AddPasswordScreen />} />
        <Route
          path="agent/verify-account"
          element={<VerifyYourAccountScreen />}
        />
        <Route
          path="agent/agency-registration"
          element={<CompanyRegistrationScreen />}
        />
        <Route
          path="agent/email-verification"
          element={<EmailverificationScreen />}
        />

        {/* Auth Routes ends */}

        {/* Agent Protected Routes starts */}
        <Route
          path="agent-flow/dashboard"
          element={
            // <AgntDashboardScreen />
            <ProtectedRoute role="localagents">
              <AgntDashboardScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/settings"
          element={
            <ProtectedRoute role="localagents">
              <JobseekerSettingsScreen />

              {/* <AgntSettingsScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/jobs-listing"
          element={
            <ProtectedRoute role="localagents">
              <JobsListingScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/jobs-details"
          element={
            <ProtectedRoute role="localagents">
              <JobsDetailsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/applied-job"
          element={
            <ProtectedRoute role="localagents">
              <AppliedJobScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/my-resume"
          element={
            <ProtectedRoute role="localagents">
              <ProfileMyResumeScreen />
              {/* <AgentMyResumeScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/resume-experience"
          element={
            <ProtectedRoute role="localagents">
              <ProfileExperienceScreen />
              {/* <AgentExperienceScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/resume-added-work-experience"
          element={
            <ProtectedRoute role="localagents">
              <ProfileAddedWorkExperienceScreen />
              {/* <AgentAddedWorkExperienceScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/resume-education-information"
          element={
            <ProtectedRoute role="localagents">
              <ProfileEducationInformationScreen />
              {/* <AgentEducationInformationScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/resume-after-added-education-information"
          element={
            <ProtectedRoute role="localagents">
              <ResumeAfterAddedEducationInformationScreen />
              {/* <AgentAfterAddedEducationInformationScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/resume-achievements-information"
          element={
            <ProtectedRoute role="localagents">
              <ResumeAchievementsInformationScreen />
              {/* <AgentAchievementsInformationScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/resume-after-added-achievements-information"
          element={
            <ProtectedRoute role="localagents">
              <ResumeAfterAddedAchivementsInformationScreen />
              {/* <AgentAfterAddedAchivementsInformationScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/resume-qualification-information"
          element={
            <ProtectedRoute role="localagents">
              <ResumeQualificationInformationScreen />
              {/* <AgentQualificationInformationScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/resume-after-added-qualification-information"
          element={
            <ProtectedRoute role="localagents">
              <ResumeAfteraddedQualificationInformationScreen />
              {/* <AgentAfteraddedQualificationInformationScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/applications"
          element={
            <ProtectedRoute role="localagents">
              <AgentApplicationsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/account-details"
          element={
            <ProtectedRoute role="localagents">
              <AgentprofileAccountDetailsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/manage-jobs"
          element={
            <ProtectedRoute role="localagents">
              <AgentManageJobsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/notifications"
          element={
            <ProtectedRoute role="localagents">
              <Notification />
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/message"
          element={
            <ProtectedRoute role="localagents">
              <JobsMessageScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="agent-flow/message/:chatId"
          element={
            <ProtectedRoute role="localagents">
              <JobsMessageScreen />
            </ProtectedRoute>
          }
        />
        {/* Agent Protected Routes ends */}

        {/* Employer Protected Routes starts */}
        <Route
          path="employer/dashboard"
          element={
            <ProtectedRoute role="employer">
              <EMPDashboardScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="employer/message"
          element={
            <ProtectedRoute role="employer">
              <JobsMessageScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="employer/message/:chatId"
          element={
            <ProtectedRoute role="employer">
              <JobsMessageScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="employer/manage-jobs"
          element={
            <ProtectedRoute role="employer">
              <ManageJobsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="employer/settings"
          element={
            <ProtectedRoute role="employer">
              <JobseekerSettingsScreen />

              {/* <EmpSettingsScreen /> */}
            </ProtectedRoute>
          }
        />
        <Route
          path="employer/post-a-job"
          element={
            <ProtectedRoute role="employer">
              <EmpPostajobScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="employer/applicants"
          element={
            <ProtectedRoute role="employer">
              <EmpApplicantsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="employer/account-details"
          element={
            <ProtectedRoute role="employer">
              <EmpAccountDetailsScreen />
            </ProtectedRoute>
          }
        />

        <Route
          path="employer/edit-job/:jobId"
          element={
            <ProtectedRoute role="employer">
              <EmpEditJobScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="employer/notifications"
          element={
            <ProtectedRoute role="employer">
              <Notification />
            </ProtectedRoute>
          }
        />
        {/* Employer Protected Routes ends */}

        {/* Jobseeker Protected Routes starts */}
        <Route
          path="jobseeker/dashboard"
          element={
            <ProtectedRoute role="jobseeker">
              <DashboardScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/message"
          element={
            <ProtectedRoute role="jobseeker">
              <JobsMessageScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/message/:chatId"
          element={
            <ProtectedRoute role="jobseeker">
              <JobsMessageScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/jobs-listing"
          element={
            <ProtectedRoute role="jobseeker">
              <JobsListingScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/jobs-details"
          element={
            <ProtectedRoute role="jobseeker">
              <JobsDetailsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/applied-job"
          element={
            <ProtectedRoute role="jobseeker">
              <AppliedJobScreen />
            </ProtectedRoute>
          }
        />

        <Route
          path="jobseeker/request-immigration-form"
          element={
            <ProtectedRoute role="jobseeker">
              <RequestImmigrationFormScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/resume-account-details"
          element={
            <ProtectedRoute role="jobseeker">
              <ProfileAccountDetailsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/my-resume"
          element={
            <ProtectedRoute role="jobseeker">
              <ProfileMyResumeScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/resume-experience"
          element={
            <ProtectedRoute role="jobseeker">
              <ProfileExperienceScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/resume-added-work-experience"
          element={
            <ProtectedRoute role="jobseeker">
              <ProfileAddedWorkExperienceScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/resume-education-information"
          element={
            <ProtectedRoute role="jobseeker">
              <ProfileEducationInformationScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/resume-after-added-education-information"
          element={
            <ProtectedRoute role="jobseeker">
              <ResumeAfterAddedEducationInformationScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/resume-achievements-information"
          element={
            <ProtectedRoute role="jobseeker">
              <ResumeAchievementsInformationScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/resume-after-added-achievements-information"
          element={
            <ProtectedRoute role="jobseeker">
              <ResumeAfterAddedAchivementsInformationScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/resume-qualification-information"
          element={
            <ProtectedRoute role="jobseeker">
              <ResumeQualificationInformationScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/resume-after-added-qualification-information"
          element={
            <ProtectedRoute role="jobseeker">
              <ResumeAfteraddedQualificationInformationScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/settings"
          element={
            <ProtectedRoute role="jobseeker">
              <JobseekerSettingsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="jobseeker/notifications"
          element={
            <ProtectedRoute role="jobseeker">
              <Notification />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
        {/* Jobseeker Protected Routes ends */}

        {/* <Route
          path="jobs/jobs-login"
          element={
            <JobseekerLoginScreen />
          }
        />
        <Route
          path="jobs/jobs-forgot-password"
          element={
            <JobseekerForgotPasswordScreen />
          }
        />
        <Route
          path="jobs/jobs-email-verification"
          element={
            <JobseekerEmailVerificationScreen />
          }
        />
        <Route
          path="jobs/jobs-reset-password"
          element={
            <JobseekerResetPasswordScreen />
          }
        />
        <Route
          path="jobs/jobs-add-password"
          element={
            <JobseekerAddPasswordScreen />
          }
        />
        <Route
          path="jobs/jobs-verify-account"
          element={
            // <JobseekerVerifyAccountScreen />
            <VerifyYourAccountScreen />
          }
        /> */}
        {/* <Route
          path="emp/login"
          element={
            <EMPLoginScreen />
          }
        />
        <Route
          path="emp/add-password"
          element={
            <EMPAddPassrowdScreen />
          }
        />
        <Route
          path="emp/company-registration"
          element={
            <EMPCompanyRegistrationScreen />
          }
        />
        <Route
          path="emp/email-verification"
          element={
            <EMPEmailVerificationScreen />
          }
        />
        <Route
          path="emp/forgot-password"
          element={
            <EMPForgotPasswordScreen />
          }
        />
        <Route
          path="emp/reset-password"
          element={
            <EMPResetPasswordScreen />
          }
        />
        <Route
          path="emp/verify-account"
          element={
            // <EMPVerifyAccountScreen />
            <VerifyYourAccountScreen />
          }
        /> */}

        {/* <Route
          path="agent/login"
          element={
            <AgntLoginScreen />
          }
        /> */}
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
